import classNames from 'classnames';
import { OpenFlag } from 'api/resort/types';
import { SnowUnit } from 'components/blocks/Unit';

import { isEmpty } from 'util/isEmpty';
import { DateTime } from 'luxon';
import { DATE_ATOM } from 'util/formatDate';
import { IResortShortReport } from 'api/region/types';
import cellStyles from './styles.module.scss';

interface ISnowfallCellProps {
  openFlag?: OpenFlag
  row?: IResortShortReport
  noValue: string
  updatedAt? : string
}

const Days3ForecastCell = ({
  openFlag, row, noValue, updatedAt,
}: ISnowfallCellProps) => {
  const forecast = row?.forecast?.slice(0, 3).reduce((acc, curr) => acc + curr.snow, 0);
  const showSnowValue = !isEmpty(forecast) && (openFlag !== OpenFlag.NoReportAvailable);
  const dateTimeNow = DateTime.now();
  const updatedAtDateTime = updatedAt && DateTime.fromFormat(updatedAt, DATE_ATOM);
  const isOutdated = updatedAt && updatedAtDateTime
   && dateTimeNow.diff(updatedAtDateTime, 'hours').hours > 48;

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      { showSnowValue && !isOutdated
        ? <SnowUnit values={forecast} />
        : noValue }
      <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>
    </span>
  );
};

export default Days3ForecastCell;
